import { Part, PartsApiResponse, generateMockParts } from '../types/parts';

interface PartsApiConfig {
  baseUrl: string;
  apiKey?: string;
}

export class PartsService {
  private config: PartsApiConfig;
  private useMockData: boolean;

  constructor(config?: Partial<PartsApiConfig>, useMockData = true) {
    this.config = {
      baseUrl: config?.baseUrl || '/api/parts',
      apiKey: config?.apiKey,
    };
    this.useMockData = useMockData;
  }

  async fetchParts(modelId: string): Promise<PartsApiResponse> {
    if (this.useMockData) {
      return this.getMockParts(modelId);
    }

    try {
      const headers: HeadersInit = {
        'Content-Type': 'application/json',
      };

      if (this.config.apiKey) {
        headers['Authorization'] = `Bearer ${this.config.apiKey}`;
      }

      const response = await fetch(`${this.config.baseUrl}/${modelId}`, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch parts: ${response.statusText}`);
      }

      const data: PartsApiResponse = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching parts:', error);
      return this.getMockParts(modelId);
    }
  }

  private getMockParts(modelId: string): PartsApiResponse {
    const parts = generateMockParts();
    return {
      parts,
      totalParts: parts.length,
      metadata: {
        modelId,
        version: '1.0.0',
        lastUpdated: new Date().toISOString(),
        language: 'en',
      },
    };
  }

  setUseMockData(useMock: boolean): void {
    this.useMockData = useMock;
  }
}

export const partsService = new PartsService({}, true);
export type { Part };
